import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetInstallationsCountByBranchResData extends ApiGenericResponse {
    installationsCountByBranch: Map<number, BranchInstallationsCountings>;

    constructor(response: AxiosResponse) {
        super(response);

        this.installationsCountByBranch = new Map<number, BranchInstallationsCountings>();
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.InstallationsCountByBranch) {
            for (let key in obj.InstallationsCountByBranch) {
                if (key != null) {
                    let branchInstallationsCountings: BranchInstallationsCountings = new BranchInstallationsCountings();
                    branchInstallationsCountings.parse(obj.InstallationsCountByBranch[key]);
                    this.installationsCountByBranch.set(Number(key), branchInstallationsCountings);
                }
            }
        }
    }
}

export class BranchInstallationsCountings {
    public visibleInstallationsCount: number;
    public globalInstallationsCount: number;

    public parse(obj: any) {
        if (obj.VisibleInstallationsCount != null) this.visibleInstallationsCount = obj.VisibleInstallationsCount;
        if (obj.GlobalInstallationsCount != null) this.globalInstallationsCount = obj.GlobalInstallationsCount;
    }
}
